import React, { Component } from 'react';
import Quill from 'quill';
import Delta from 'quill-delta';
import createQuill from './Quill';

import './QuillInput.scss';

class QuillInput extends Component {
  constructor(props) {
    super(props);
    this.quill = null;
    this.editor = null;
    this.state = {
      lastUpdate: false,
    };
  }

  componentDidMount = () => {
    this.quill = createQuill(this.editor, {
      modules: {
        toolbar: false,
        keyboard: {
          bindings: {
            noEnter: {
              key: 13,
              handler: (range, context) => {
                let delta = new Delta().retain(range.index).delete(context.suffix.length);

                this.quill.updateContents(delta, Quill.sources.USER);
                const { onEnter } = this.props;
                if (onEnter) onEnter(context.suffix);
              },
            },
          },
        },
      },
      formats: ['link'],
    });

    this.quill.on('text-change', () => {
      const newValue = this.handleGetCurrentContents();
      this.setState({ lastUpdate: newValue });
      const { onChange, name } = this.props;
      let attrName = name || 'value';
      if (onChange) {
        onChange({ [attrName]: newValue });
      }
    });

    this.quill.root.addEventListener('blur', event => {
      setTimeout(() => {
        var selection = this.quill.getSelection();
        if (selection) {
          this.handleSetCurrentContents(this.handleGetCurrentContents());
          this.quill.setSelection(selection);
          this.quill.focus();
        } else {
          const { onBlur } = this.props;
          if (onBlur) onBlur({ target: { value: this.handleGetCurrentContents() } });
        }
      }, 50);
    });

    this.quill.root.addEventListener('focus', event => {
      const { onFocus } = this.props;
      if (onFocus) onFocus({ target: { value: this.handleGetCurrentContents() } });
    });

    if (this.props.value) this.handleSetCurrentContents(this.props.value);
  };

  handleGetCurrentContents = () => {
    if (!this.quill) return '';
    return this.quill.getText().replace('\n', '');
  };

  handleSetCurrentContents = html => {
    if (!this.quill) return;
    this.quill.setContents(this.quill.clipboard.convert(html));
    this.quill.history.clear();
  };

  componentWillReceiveProps = nextProps => {
    if (nextProps.value !== this.props.value && nextProps.value !== this.state.lastUpdate) {
      this.handleSetCurrentContents(nextProps.value);
    }

    if (this.quill) {
      this.quill.enable(!nextProps.disabled);
    }
  };

  render() {
    const { id } = this.props;
    let props = {
      className: `quill-input ${this.props.className || ''}`,
    };
    if (id) props.id = id;

    return <div {...props} ref={r => (this.editor = r)} />;
  }
}

export default QuillInput;
